import Box from "@mui/material/Box";
import TableHeader from "../../../components/TableHeader/TableHeader";
import useEmployeeSelection from "../../../hooks/useEmployeeSelection";
import styles from "./styles.module.css";
import EarlyLeaving from "../../../components/EarlyLeavingReport/EarlyLeavingReport";

export default function EarlyLeavingReport() {
  const { currentEmployee, emplist, onCurrentEmployeeChange } =
    useEmployeeSelection();

  return (
    <Box className={styles.mainContainer}>
      <TableHeader
        heading="Early Leaving Report"
        emplist={emplist}
        handleChange={onCurrentEmployeeChange}
        currentEmployee={currentEmployee.employee_id}
      />
      <EarlyLeaving currentEmployeeId={currentEmployee.employee_id} />
    </Box>
  );
}
